import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=66abf42f&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=66abf42f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66abf42f",
  null
  
)

export default component.exports